import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import visionIcon from '../assets/imgs/vision.webp';
import missionIcon from '../assets/imgs/mission.webp';

const Vision = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Adjust duration to control animation speed
      easing: 'ease-in-out', // Add custom easing for smoother animation
    });
  }, []);

  return (
    <div className="container">
      <main className="main-content">
        <div className="mission-vision">
          <div className="mission-box" data-aos="fade-right"> {/* Animation added */}
            <img src={missionIcon} loading="lazy" alt="Mission Icon" className="MVicon" />
            <h2>Mission</h2>
            <h3>Connecting Dreams to Reality, One Home at a Time.</h3>
            <p>Our mission is to make homeownership accessible by connecting individuals and families to their dream properties. We strive to provide exceptional service, ensuring that each client’s journey to finding a home is seamless and fulfilling.</p>
          </div>

          <div className="vision-box" data-aos="fade-left" data-aos-delay="200"> {/* Animation with delay */}
            <img src={visionIcon} loading="lazy" alt="Vision Icon" className="MVicon" />
            <h2>Vision</h2>
            <h3>Building Communities, Shaping Futures.</h3>
            <p>We envision vibrant, sustainable communities where every home serves as a foundation for a better future. By shaping neighborhoods with integrity and innovation, we aim to create lasting value for generations to come.</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Vision;
